// Angular
import { NgModule } from '@angular/core';

// Afidium
import { QuotationService } from './quotation.service';
import { SharedData } from 'libraries/hotel/shared-data';
import { HotelResourceModule } from "libraries/service/resources/hotel/hotelResource.module";
import { HotelResourceService } from "libraries/service/resources/hotel/hotelResource.service";

@NgModule({
    imports: [
        HotelResourceModule,
    ],
    providers: [
        QuotationService,
        SharedData,
        HotelResourceService,
    ],
})
export class QuotationServiceModule {}
